import { isObject } from '@scalar/helpers/object/is-object';
const defaultTransform = (node) => {
    // Unresolved references have no value; callers must account for that state.
    return node['$ref-value'];
};
/**
 * Transform for getResolvedRef that merges sibling properties of a $ref wrapper
 * onto the dereferenced value. Wrapper siblings take precedence over the resolved value,
 * which matches OpenAPI 3.1 semantics where annotations alongside $ref override the target.
 */
export const mergeSiblingReferences = (node) => {
    const { '$ref-value': value, ...rest } = node;
    // A reference can land on something that is not a record: a pointer that aims at a string
    // (`$ref: '#/info/title'`), one that was never resolved, or one whose target is an array. Spreading
    // any of those copies it index by index, so a reference to a title becomes `{ 0: 'G', 1: 'a', … }`
    // and every consumer downstream treats those digits as real properties. There is nothing to merge
    // siblings onto in that case, so only the siblings survive.
    if (!isObject(value)) {
        return rest;
    }
    return { ...value, ...rest };
};
export function getResolvedRef(node, transform = defaultTransform) {
    if (typeof node === 'object' && node !== null && '$ref' in node) {
        return transform(node);
    }
    return node;
}
